import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import PublicLayout from "./PublicLayout";
import NetworkCanvas from "./NetworkCanvas";
import { properties } from "../properties";

export default function SampleNetworkGraph() {
    const navigate = useNavigate();

    const [smallScreen, setSmallScreen] = useState(window.innerWidth < 991);
    const [loading, setLoading] = useState(!smallScreen);

    useEffect(() => {
        const onResize = () => {
            const small = window.innerWidth < 991;
            setSmallScreen(small);
            if (small) setLoading(false);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    return (
        <PublicLayout activePage="Submissions">
                    <button className="chpw-back" onClick={() => navigate("/sample/submission")}>
                        <ArrowLeft size={14} />
                        Back to Submission
                    </button>

                    <div className="score-history-card" style={{ marginBottom: 16 }}>
                        <p className="score-history-title">Network Discovery</p>
                        <p className="score-history-sub">Citation and similarity network for your manuscript</p>
                    </div>

                    {smallScreen ? (
                        <div className="submissions-card" style={{ padding: "32px 24px", textAlign: "center" }}>
                            <p className="settings-empty">Network Discovery is not available on small screens or mobile devices.</p>
                        </div>
                    ) : (
                        <div className="submissions-card" style={{ overflow: "hidden", padding: 0 }}>
                            {loading && (
                                <div style={{ height: "75vh", position: "relative", background: "#0f1a14", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <NetworkCanvas />
                                    <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                                        <p style={{ color: "rgba(255,255,255,0.75)", fontSize: 14, letterSpacing: "0.04em" }}>Building your network…</p>
                                    </div>
                                </div>
                            )}
                            <iframe
                                title="sample-graph"
                                src={`${properties.host}/sample/graph`}
                                onLoad={() => setTimeout(() => setLoading(false), 3000)}
                                style={{
                                    display: loading ? "none" : "block",
                                    width: "100%",
                                    height: "75vh",
                                    border: "none",
                                }}
                            />
                        </div>
                    )}
        </PublicLayout>
    );
}
